import { mapGetters } from 'vuex'

export const BaseVue = {
  data() {
    return {
      vueminus: -1,
      vuefour: 4,
      vuetrue: true,
      vuefalse: false,
      domain: "",
      defaultCover: "",
      initLoading: false,
      
      // 颜色定义
      DefaultColor: "#FFFFFF",
      PrimaryColor: "#409EFF",
      SuccessColor: "#67C23A",
      WarningColor: "#E6A23C",
      DangerColor: "#F56C6C",
      InfoColor: "#909399",
      
      TextPrimary: "#303133",
      TextPrimary2: "#606266",
      TextPrimary3: "#909399",
      TextPrimary4: "#C0C4CC",
      
      BorderPrimary: "#DCDFE6",
      BorderPrimary2: "#E4E7ED",
      BorderPrimary3: "#EBEEF5",
      BorderPrimary4: "#F2F6FC"
    }
  },
  
  computed: {
    // Vuex getters映射
    ...mapGetters('profileModule', {
      roleinfo: 'roleinfos',
      roleid: 'roleid',
      isadmin: 'isadmin'
    }),
    
    // 数值常量
    vuezero() {
      return 0
    },
    vueone() {
      return 1
    },
    vuetwo() {
      return 2
    },
    vuethree() {
      return 3
    },
    
    // 权限相关计算属性
    isAdmin() {
      return this.isadmin
    },
    isRoleinfo() {
      return this.roleinfo
    },
    isSystemManager() {
      return this.roleid == "00001"
    },
    isUnitManager() {
      return this.roleid == "00003"
    },
    isPartyManager() {
      return this.roleid == "00002"
    }
  },
  
  methods: {
    hasSystemManagerMode() {
      return true
    }
  },
  
  mounted() {
    // console.log("mounted in base vue", this.roleinfo)
  }
}